import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoSearchDto } from '../../../shared/modules/base/dtos/base-proto-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingTierItemDto } from '../../../shared/modules/pricing-tier-items/dtos/pricing-tier-item.dto';
import { VehicleCategoryAvailabilityModeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-availability-mode.enum';
import { AssetFeatureItemDto } from '../../asset-feature-items/dtos/asset-feature-item.dto';
import { AssetMetadataDto } from '../../asset-metadata/dtos/asset-metadata.dto';
import { AssetUnavailabilityItemDto } from '../../asset-unavailability-items/dtos/asset-unavailability-item.dto';
import { VehicleGroupDto } from '../../vehicle-groups/dtos/vehicle-group.dto';
import { AssetTypeEnum } from '../enums/asset-type.enum';

import { AssetAvailabilityDto } from './asset-availability.dto';
import { AssetQuotationDto } from './asset-quotation.dto';

/**
 * Asset DTO for search
 */
@CaslSubject(AppSubjectEnum.ASSET)
export class AssetSearchDto extends BaseProtoSearchDto {
	tenantOrgId?: string;
	areaUuid!: string;
	name!: string;
	type!: AssetTypeEnum;
	availabilityMode?: VehicleCategoryAvailabilityModeEnum;
	availability?: AssetAvailabilityDto;
	quotation?: AssetQuotationDto;
	pricingItems?: PricingTierItemDto[];
	unavailabilityItems?: AssetUnavailabilityItemDto[];
	featureItems?: AssetFeatureItemDto[];
	metadata?: AssetMetadataDto[];
	files?: FileDto[];
	vehicleGroup?: VehicleGroupDto;
}
